import { createFileRoute } from "@tanstack/react-router";
import { cecosQueryOptions, clavesSatQueryOptions, cuentasQueryOptions } from "@/features/catalogos/hooks/use-catalogos";
import { ProrrateoPage } from "@/features/prorrateo/components/ProrrateoPage";
import { prorrateoQueryOptions } from "@/features/prorrateo/hooks/use-prorrateo";
import { solicitudQueryOptions } from "@/features/solicitudes/hooks/use-solicitud";
import { ErrorAlert } from "@/components/ui";

/**
 * Ruta `/solicitudes/$id/prorrateo` · file delgado.
 *
 * El `loader` precarga todos los datos que ProrrateoPage consume con
 * `useSuspenseQuery` · cuando el componente monta, su árbol nunca
 * está en estado loading (cero flicker en navegación).
 */
export const Route = createFileRoute("/_authed-tw/solicitudes/$id/prorrateo")({
  loader: ({ context: { queryClient }, params: { id } }) =>
    Promise.all([
      queryClient.ensureQueryData(prorrateoQueryOptions(id)),
      queryClient.ensureQueryData(solicitudQueryOptions(id)),
      queryClient.ensureQueryData(cecosQueryOptions),
      queryClient.ensureQueryData(cuentasQueryOptions),
      queryClient.ensureQueryData(clavesSatQueryOptions),
    ]),
  component: ProrrateoPage,
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
